// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1hsr6","colMin":"styles_colMin__3IJBu","colCheckbox":"styles_colCheckbox__cA3zj"};